import React from 'react';
import axios from 'axios';
import { Auth, I18n } from 'aws-amplify';
import { Link } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import FormHelperText from '@material-ui/core/FormHelperText';
import { createMuiTheme } from '@material-ui/core/styles';
import getHrefByLocaleLaplaceidQa from '../util/getHrefByLocale.js';
import { SES_API, CHECK_CODE_API } from '../../configures/val.js';

import LapDialog from '../util/laplaceDialog.js';
import { cleanUpUserRelations } from '../util/callApi.js';

const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#ffffff',
      main: '#d6d6d6',
      dark: '#a5a5a5',
      contrastText: '#666666',
    },
    secondary: {
      light: '#ffebdb',
      main: '#ffb8a9',
      dark: '#ff9f8b',
      contrastText: '#f62b00',
    },
  },
});

const styles = (theme) => ({
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  formControl: {
    display: 'block',
  },
  marginUp: {
    marginTop: 20,
  },
  secondary: {
    marginBottom: '48px',
    marginLeft: '248px',
    width: '180px',
    height: '44px',
    color: '#ffffff',
    backgroundColor: '#1a66ff',
    boxShadow: 'none',
  },
  secondary02: {
    marginTop: '20px',
    marginBottom: '20px',
    width: '180px',
    height: '44px',
    color: '#ffffff',
    backgroundColor: '#ff2d01',
    boxShadow: 'none',
  },
  inputNewaddress: {
    width: '380px',
  },
  messageEditaddress: {
    paddingTop: '24px',
    paddingBottom: '16px',
    lineHeight: '1.7',
    fontSize: '16px',
    fontWeight: 'bolder',
    color: '#77787d',
  },
});

class editAddress extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openRemove: false,
      openConfirmCode: false,
      openFinishConfirm: false,
      isDisabled: true,
      errorAddressStr: '',
      isShowEnterCode: false,
      codeErrorstr: '',
      isCodeButtonDisabled: true,
    };
    this.myDate = '';
    this.userEmail = '';
  }
  setUserEmail = (attr) => {
    for (let i = 0; i < attr.length; i++) {
      if ('email' === attr[i].Name) {
        this.userEmail = attr[i].Value;
        return;
      }
    }
  };
  checkUser() {
    const that = this;
    return Auth.currentAuthenticatedUser()
      .then((user) => {
        if (!that._isMounted) {
          return;
        }
        Auth.userAttributes(user)
          .then((attrRet) => {
            // ログイン済みで正しくトークンが生きている
            this.setUserEmail(attrRet);
            return;
          })
          .catch((attrErr) => {
            // トークンが死んでいる可能性がある
            window.history.pushState('', '', '/');
            Auth.signOut().then(() => this.props.authProps.onStateChange('signIn'));
          });
      })
      .catch((err) => {
        if (!that._isMounted) {
          return;
        }
        window.history.pushState('', '', '/');
        Auth.signOut().then(() => this.props.authProps.onStateChange('signIn'));
      });
  }
  componentDidMount() {
    this._isMounted = true;
    this.checkUser();
    this.props.updateHeader();
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  handleChange = (event) => {
    let error = this.state.errorAddressStr;
    let addressButtonState = this.state.isDisabled;
    let codeButtonState = this.state.isCodeButtonDisabled;
    let codeError = this.state.codeErrorstr;
    if (event.target.name === 'newaddress') {
      if (
        event.target.value.match(
          /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
        )
      ) {
        addressButtonState = false;
        error = '';
      } else {
        addressButtonState = true;
        error = I18n.get('Mail address style is not valid or not entered.');
      }
    }
    if (event.target.name === 'code') {
      if (event.target.value.match(/^[a-zA-Z0-9]+$/)) {
        codeButtonState = false;
        codeError = '';
      } else {
        codeButtonState = true;
        codeError = I18n.get('Verification code style is not valid or not entered.');
      }
    }
    this.setState({
      [event.target.name]: event.target.value,
      isDisabled: addressButtonState,
      isCodeButtonDisabled: codeButtonState,
      errorAddressStr: error,
      codeErrorstr: codeError,
    });
  };

  update = () => {
    this.checkUser();
    // メールが既にcheckUser() 時のものと同じなら変更できない
    if (this.userEmail === this.state.newaddress) {
      this.setState({
        errorAddressStr: I18n.get('You can not update to currently used mail address.'),
      });
      return;
    }
    this.myDate = new Date().getTime().toString();

    axios
      .post(SES_API, {
        address: this.state.newaddress,
        date: this.myDate,
        lang: window.LAPLACEID_LOCALE,
      })
      .then((response) => {
        this.setState({ isShowEnterCode: true, openConfirmCode: true });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  showVerificationArea = () => {
    const { classes } = this.props;
    return (
      <div className='mypageUserinfoItem'>
        <div className={classes.marginUp}>
          <Typography className={classes.messageEditaddress} gutterBottom>
            {I18n.get('You will receive verification code from new address.')}
            <br />
            {I18n.get(
              'Enter the 6 digit verification code described in the mail body and send it.'
            )}
          </Typography>
          <div>
            <dl className='mypageInputFlex'>
              <dt>
                <Typography>{I18n.get('Regist verification code')}</Typography>
              </dt>
              <dd>
                <FormControl className={classes.formControl}>
                  <input
                    className='mypageInputStyle'
                    name='code'
                    id='code'
                    type='text'
                    placeholder={I18n.get('Code')}
                    onChange={this.handleChange}
                  />
                  <FormHelperText className='mypageErrorText' id='code-helper-text'>
                    {this.state.codeErrorstr}
                  </FormHelperText>
                </FormControl>
              </dd>
            </dl>
          </div>
          <div>
            <Button
              className={classes.secondary}
              onClick={this.enterCode}
              variant='contained'
              disabled={this.state.isCodeButtonDisabled}
            >
              {I18n.get('Submit')}
            </Button>
          </div>
        </div>
      </div>
    );
  };
  blankArea = () => {
    return <div></div>;
  };
  enterCode = () => {
    this.checkUser();
    axios
      .post(CHECK_CODE_API, {
        address: this.state.newaddress,
        date: this.myDate,
        code: this.state.code,
      })
      .then((response) => {
        if (response.data.statusCode === 200) {
          const param = {
            email: this.state.newaddress,
          };
          Auth.currentAuthenticatedUser().then((result) => {
            // この時点ではverifiedなaddress
            Auth.updateUserAttributes(result, param)
              .then((updResult) => {
                // ここで verifiedではなくなる
                Auth.signOut().then(() => {
                  this.setState({
                    openFinishConfirm: true,
                  });
                });
              })
              .catch((err) => {
                console.log('updateUserAttributes-Err');
                this.setState({ codeErrorstr: I18n.get(err.message) });
              });
          });
        } else {
          const tmpStr = I18n.get('Invalid verification code provided, please try again.');
          this.setState({ codeErrorstr: tmpStr });
        }
      })
      .catch((err) => {
        console.log('editAddress Error');
        this.setState({ codeErrorstr: I18n.get(err.message) });
      });
  };
  toOpen = () => {
    this.setState({ openRemove: true });
  };
  toClose = () => {
    this.setState({ openRemove: false });
  };
  toConfirmClose = () => {
    this.setState({ openConfirmCode: false });
  };
  toFinishClose = () => {
    this.setState({ openFinishConfirm: false });
  };
  toSignIn = () => {
    window.history.pushState('', '', '/');
    this.props.authProps.onStateChange('signIn');
  };
  remove = async () => {
  try {
    this.checkUser();
    const user = await Auth.currentAuthenticatedUser();

    await cleanUpUserRelations();
    await new Promise((resolve, reject) => {
      user.deleteUser((error) => {
        if (error) {
          return reject(error);
        }
        resolve();
      });
    });

    try {
      await Auth.signOut();
      window.history.pushState('', '', '/');
      this.props.authProps.onStateChange('signIn');
    } catch (err) {
      console.log('signOut-err');
      console.log(err);
    }
  } catch (err) {
    console.log('remove err::');
    console.log(err);
  }
};

  render() {
    const { classes } = this.props;

    return (
      <div className='mypageContainer editAddress'>
        <div className='mypageBreadcrumbs'>
          <Link to='/'>{I18n.get('User profile')}</Link>&nbsp;&nbsp;＞&nbsp;&nbsp;
          {I18n.get('Edit your id (mail address)')}
        </div>
        <p className='mypageTitle'>
          <span class='mypageTitleIcon'></span>
          {I18n.get('Edit your id (mail address)')}
        </p>
        <div className='mypageUserinfoItem'>
          <Typography className={classes.messageEditaddress} gutterBottom>
            {I18n.get('Enter your new mail address.')}
          </Typography>
          <dl className='mypageInputFlex'>
            <dt>
              <Typography>{I18n.get('New mail address')}</Typography>
            </dt>
            <dd>
              <FormControl className={classes.formControl}>
                <input
                  className='mypageInputStyle large'
                  name='newaddress'
                  id='newaddress'
                  type='email'
                  placeholder={I18n.get('New mail address')}
                  onChange={this.handleChange}
                />
                <FormHelperText className='mypageErrorText' id='newaddress-helper-text'>
                  {this.state.errorAddressStr}
                </FormHelperText>
              </FormControl>
            </dd>
          </dl>
          <Button
            className={classes.secondary}
            onClick={this.update}
            variant='contained'
            disabled={this.state.isDisabled}
          >
            {I18n.get('Send Code')}
          </Button>
          {getHrefByLocaleLaplaceidQa()}
        </div>
        {this.state.isShowEnterCode ? this.showVerificationArea() : this.blankArea()}
        <p className='mypageTitle'>
          <span class='mypageTitleIcon'></span>
          {I18n.get('Delete Laplace ID')}
        </p>
        <div className='mypageUserinfoItem'>
          <Button
            className={classes.secondary02}
            onClick={this.toOpen}
            variant='contained'
            disabled={this.props.amIPrimaryAdmin}
          >
            {I18n.get('Delete ID')}
          </Button>
          {this.props.amIPrimaryAdmin && (
            <Typography variant='subheading'>
              {I18n.get('The ID of the admin (primary) user cannot be discontinued.')}
            </Typography>
          )}
        </div>
        <div>
          <Typography>{this.state.updateError}</Typography>
        </div>
        <LapDialog
          title={I18n.get('Delete Laplace ID')}
          contentText={I18n.get('Do you delete your Laplace ID?')}
          theme={theme}
          firstButtonText={I18n.get('Cancel')}
          firstButtonFunc={this.toClose}
          secondButtonText={I18n.get('Delete')}
          secondButtonFunc={this.remove}
          open={this.state.openRemove}
          toClose={this.toClose}
        />
        <LapDialog
          contentText={I18n.get(
            'You will receive the verification code. Please enter the verification code described in the mail body.'
          )}
          open={this.state.openConfirmCode}
          toClose={this.toConfirmClose}
        />
        <LapDialog
          contentText={
            <div>
              {I18n.get('Your mail address is verified.')}
              <br />
              {I18n.get('Please log in again and make the second confirmation.')}
              <br />
              {I18n.get('You can resubmit by clicking again')}
            </div>
          }
          open={this.state.openFinishConfirm}
          toClose={this.toFinishClose}
          onExit={this.toSignIn}
        />
      </div>
    );
  }
}

export default withStyles(styles)(editAddress);
